import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoTipoProgramaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoTipoProgramaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoTipoProgramaService(): Observable<BodyListResponse<CatalogoTipoProgramaDTO>> {
    return this.http.get<BodyListResponse<CatalogoTipoProgramaDTO>>(API_URL + '/api/v1/catalogoTipoPrograma/todos');
  }

  guardarCatalogoTipoProgramaService(catalogoTipoProgramaDTO: CatalogoTipoProgramaDTO): Observable<CatalogoTipoProgramaDTO> {
    return this.http.post<CatalogoTipoProgramaDTO>(API_URL + '/api/v1/catalogoTipoPrograma', catalogoTipoProgramaDTO);
  }

  getCatalogoTipoProgramaPorCodigoCatalogoTipoProgramaService(codigoCatalogoTipoPrograma: string): Observable<BodyResponse<CatalogoTipoProgramaDTO>> {
    return this.http.get<BodyResponse<CatalogoTipoProgramaDTO>>(API_URL + '/api/v1/catalogoTipoPrograma/' + codigoCatalogoTipoPrograma);
  }
}
